module.exports = __webpack_public_path__ + "SN.png?48ac6a05075c614ccbb83964758598b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/SN.png
// module id = 407
// module chunks = 0